import React from 'react';
import { WebsiteDesignProps } from './types';
import { Cloud, Heart, Star, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";

const PastelDream: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Dreamland Nursery";

    return (
        <div className="bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 min-h-screen font-sans text-purple-900">
             <nav className="p-6 flex justify-between items-center bg-white/50 backdrop-blur-md rounded-b-[3rem] shadow-sm mx-4">
                 <div className="text-2xl font-bold tracking-tight text-pink-500 flex items-center gap-2">
                     <Cloud className="fill-pink-200" /> {schoolName}
                 </div>
                 <Button className="bg-gradient-to-r from-pink-400 to-purple-400 text-white rounded-full font-bold border-2 border-white shadow-lg hover:shadow-xl hover:scale-105 transition-all">
                     Parent Log
                 </Button>
             </nav>

             <main className="container mx-auto px-6 py-16 text-center">
                 <div className="inline-block p-4 bg-white/60 backdrop-blur rounded-full mb-8 animate-bounce delay-700">
                     <span className="text-sm font-bold text-purple-600 uppercase tracking-widest flex items-center gap-2">
                         <Sparkles size={16} /> Where magic happens
                     </span>
                 </div>
                 
                 <h1 className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 mb-8 drop-shadow-sm tracking-tight">
                     Dream Big, <br/> Little One.
                 </h1>
                 
                 <p className="text-xl text-purple-700/70 max-w-xl mx-auto mb-12 font-medium">
                     A soft, nurturing world full of wonder, imagination, and gentle learning for your precious stars.
                 </p>

                 <div className="relative max-w-4xl mx-auto mb-20">
                     <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-200 rounded-full blur-2xl opacity-60 animate-pulse"></div>
                     <div className="absolute bottom-0 left-0 w-40 h-40 bg-pink-200 rounded-full blur-2xl opacity-60 animate-pulse delay-1000"></div>
                     
                     <div className="grid grid-cols-2 md:grid-cols-3 gap-6 relative z-10">
                         <div className="rounded-[2rem] overflow-hidden shadow-xl border-4 border-white transform hover:-translate-y-2 transition-transform duration-500">
                             <img src="https://images.unsplash.com/photo-1545558014-8692077e9b5c?q=80&w=2070&auto=format&fit=crop" className="w-full h-48 object-cover" alt="Happy Kids" />
                         </div>
                         <div className="rounded-[2rem] overflow-hidden shadow-xl border-4 border-white transform translate-y-8 hover:translate-y-6 transition-transform duration-500">
                             <img src="https://images.unsplash.com/photo-1566004100631-35d015d6a491?q=80&w=2070&auto=format&fit=crop" className="w-full h-48 object-cover" alt="Playing" />
                         </div>
                         <div className="hidden md:block rounded-[2rem] overflow-hidden shadow-xl border-4 border-white transform hover:-translate-y-2 transition-transform duration-500">
                             <img src="https://images.unsplash.com/photo-1594608661623-aa0bd3a69d98?q=80&w=1848&auto=format&fit=crop" className="w-full h-48 object-cover" alt="Art" />
                         </div>
                     </div>
                 </div>

                 <div className="flex justify-center gap-8">
                     {[
                         { icon: Star, color: "text-yellow-400", bg: "bg-yellow-100", label: "Creative" },
                         { icon: Heart, color: "text-pink-400", bg: "bg-pink-100", label: "Loving" },
                         { icon: Cloud, color: "text-blue-400", bg: "bg-blue-100", label: "Safe" },
                     ].map((item, i) => (
                         <div key={i} className="flex flex-col items-center gap-3">
                             <div className={`w-16 h-16 ${item.bg} rounded-full flex items-center justify-center shadow-inner`}>
                                 <item.icon className={`${item.color} fill-current`} size={32} />
                             </div>
                             <span className="font-bold text-purple-800">{item.label}</span>
                         </div>
                     ))}
                 </div>
             </main>
        </div>
    );
};

export default PastelDream;
